import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function CookieBanner() {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(
    () => !localStorage.getItem('cookie_consent')
  )

  if (!visible) return null

  function handleAccept() {
    localStorage.setItem('cookie_consent', 'accepted')
    window.dispatchEvent(new Event('growlab:consentChanged'))
    setVisible(false)
  }

  function handleDecline() {
    localStorage.setItem('cookie_consent', 'declined')
    window.dispatchEvent(new Event('growlab:consentChanged'))
    setVisible(false)
  }

  return (
    <div className="cookie-banner" role="dialog" aria-label="Cookie consent">
      <p className="cookie-message">
        {t('cookie.message')}{' '}
        <Link to="/cookie-policy" className="cookie-link">{t('legal.cookiePolicy')}</Link>
      </p>
      <div className="cookie-actions">
        <button className="cookie-btn-accept" onClick={handleAccept}>
          {t('cookie.accept')}
        </button>
        <button className="cookie-btn-decline" onClick={handleDecline}>
          {t('cookie.decline')}
        </button>
      </div>
    </div>
  )
}
